import {
  fetchAPI,
  TASKS_SERVICE_URL,
} from "@coworker/app/src/hooks/API/tasks.service.helper";
import { useQueries, useQuery } from "@tanstack/react-query";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import { ImageSize } from "../enums/imageSizes";
import { ImageDetails } from "../types/ImageDetailsType";
import { FetchApiResponse } from "@coworker/apprestructured/src/shared/types/fetchApiResponseType";
import { ImageSignedUrlType } from "@coworker/apprestructured/src/tasks/types/imageSignedUrlType";

async function fetchSignedUrl(
  filename: string,
  size: ImageSize = ImageSize.LARGE
) {
  const path = `storage/get_signed_urls?size=${size}&filenames=${filename}`;
  const url = `${TASKS_SERVICE_URL}/v1/${path}`;
  const { result } = (await fetchAPI(
    "GET",
    url
  )) as FetchApiResponse<ImageSignedUrlType>;

  return result?.urls;
}

export function useGetImageSignedUrl(filename: string, size: ImageSize) {
  return useQuery({
    queryKey: ["image", "url", filename, size],
    queryFn: async () => await fetchSignedUrl(filename, size),
    staleTime: INTERVAL.DAY,
    refetchOnWindowFocus: false,
    enabled: !!filename && !!size,
  });
}

export function useGetImagesSignedUrls(
  taskImagesDetails: ImageDetails[] | undefined
) {
  return useQueries({
    queries:
      taskImagesDetails?.map((taskImage) => {
        return {
          queryKey: ["image", "url", taskImage.file_name, ImageSize.LARGE],
          queryFn: () => fetchSignedUrl(taskImage.file_name),
          refetchOnWindowFocus: false,
          enabled: !!taskImage.file_name,
          staleTime: INTERVAL.DAY,
        };
      }) ?? [],
  });
}
